import { dataBackgroundSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBackgroundSolid = /*#__PURE__*/createIcon(dataBackgroundSolid)
export default IconBackgroundSolid
